import React from 'react';
import type { CardLinkAsset, ConciergeTileAsset, PropAsset } from '../../propValues.types';
import { CardTileConcierge } from './components/CardTileConcierge';
import { CardLink } from './components/CardLink';
import type { CardTileSource } from './components/CardTile';
import { CardTile } from './components/CardTile';
import { ValuePropCard } from './components/ValueProps/ValuePropCard';
import { isConciergeServiceCategory } from '@apps/card/routes/Concierge/config';
import type { StationeryTemplateCategoryEnum } from '@graphql/generated-base';
import type { CardFormat } from '../../../ProductDetailsPage/constants';
import type { StationeryTemplate } from '../../DesignsGallery.types';

export type ConciergeSelectedEvent = {
  id: string;
};

export type CardEventType = ConciergeSelectedEvent & { type: 'conciergeselectedevent' };

export type GalleryTemplate = StationeryTemplate & {
  type: 'template';
  // Set when the gallery-order feature flag repeats a template with a specific
  // colorway (search inactive only). `colorwayOverride` pre-selects that colorway;
  // `instanceKey` gives each repeated tile a stable, unique React key.
  colorwayOverride?: string;
  instanceKey?: string;
};
export type GalleryValueProp = PropAsset & { type: 'prop' };

export type GalleryItemData = GalleryValueProp | GalleryTemplate | (CardLinkAsset & { type: 'cardlink' }) | (ConciergeTileAsset & { type: 'concierge' });

type GalleryItemProps = {
  preferredFormat?: CardFormat;
  eventId?: string;
  data: GalleryItemData;
  eventDesignThemeId?: string;
  onCardSelect: (event: CardEventType) => void;
  hideCardTileTag?: boolean;
  cardTileSource: CardTileSource;
  currentCategory: StationeryTemplateCategoryEnum;
};

export const GalleryItem = (props: GalleryItemProps) => {
  const { data, preferredFormat, cardTileSource, onCardSelect, eventId, hideCardTileTag, currentCategory } = props;
  switch (data.type) {
    case 'prop':
      return <ValuePropCard data={data} />;
    case 'cardlink':
      return <CardLink data={data} />;
    case 'template':
      return (
        <CardTile
          cardTileSource={cardTileSource}
          data={data}
          hideTag={hideCardTileTag}
          eventId={eventId}
          preferredFormat={preferredFormat}
        />
      );
    case 'concierge':
      if (isConciergeServiceCategory(currentCategory)) {
        return (
          <CardTileConcierge
            category={currentCategory}
            data={data}
            onSelect={onCardSelect}
          />
        );
      }
      return null;
  }
};
